<template>
  <div>
    <b-table :data="documents" :bordered="true" :striped="true" :hoverable="true">
      <template v-slot="props">
        <b-table-column field="file_name" label="File Name">{{ props.row.file_name }}</b-table-column>
        <b-table-column field="document_name" label="Image"><img class="image is-64x64" :src="props.row.file_url" :alt="props.row.file_name"></b-table-column>
        <b-table-column field="actions" label="Actions">
          <button class="button is-danger" @click="handleDocumentDelete(props.row)">DELETE</button>
        </b-table-column>
      </template>

      <template v-slot:empty>
        <div class="has-text-grey has-text-centered has-padding-30 has-margin-0 is-size-4">
          <b-icon icon="cloud-upload-outline" size="is-large"></b-icon>
          <div>No documents uploaded yet. Please upload a supporting document, which may include nimasa required documents, safety required documents, etc. If any.</div>
        </div>
      </template>
    </b-table>
    <b-loading :is-full-page="true" :active.sync="deleting" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import DeleteCertificateDocumentMutation from "@/modules/shippersModule/api/graphql/mutations/DeleteCertificateDocument";

import { SHIPPER_MUTATION_TYPES } from "@/store/mutation-types";
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("shippers");

export default {
  name: "UploadedDocuments",

  props: {
    documents: { type: Array, required: true }
  },

  data() {
    return {
      deleting: false
    };
  },

  methods: {
    ...mapMutations({
      deleteDocumentFromStore:
        SHIPPER_MUTATION_TYPES.DELETE_UPLOADED_CERTIFICATE_DOCUMENT
    }),

    handleDocumentDelete: function(document) {
      this.$dialog.confirm({
        title: "Deleting uploaded document",
        message:
          "Are you sure you want to <b>delete</b> this document? This action cannot be undone.",
        confirmText: "Yes, Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.deleteDocument(document);
        }
      });
    },

    deleteDocument: function(document) {
      this.deleting = true;

      this.$apollo
        .mutate({
          mutation: DeleteCertificateDocumentMutation,
          variables: {
            id: document.id
          }
        })
        .then(response => {
          const data = response.data.DeleteCertificateDocument;
          this.deleteDocumentFromStore(document.id);
          this.$toast.open({
            duration: 4000,
            message: "Document deleted successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message: "Document failed to delete. Please try again",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  }
};
</script>
